(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pm-applications-explorer"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      const choices = [...root.querySelectorAll('[data-scene-choice]')];
      const scenes = [...root.querySelectorAll('[data-scene]')];
      const details = [...root.querySelectorAll('[data-detail]')];
      const showAll = root.querySelector('[data-show-all]');
      const sceneStatus = root.querySelector('[data-scene-status]');
      const brief = root.querySelector('[data-brief]');
      const application = root.querySelector('[data-brief-application]');
      const equipment = root.querySelector('[data-brief-equipment]');
      const evidence = root.querySelector('[data-brief-evidence]');
      const model = root.querySelector('[data-brief-model]');
      const modelField = root.querySelector('[data-model-field]');
      const summary = root.querySelector('[data-brief-summary]');
      const printSummary = root.querySelector('[data-print-summary]');
      const briefState = root.querySelector('[data-brief-state]');
      const copyState = root.querySelector('[data-copy-state]');
      const copyButton = root.querySelector('[data-copy-brief]');
      const resetButton = root.querySelector('[data-reset-brief]');
      const rebuildButton = root.querySelector('[data-rebuild-brief]');
      const messages = root.querySelector('[data-ax-messages]').dataset;
      const mobile = window.matchMedia('(max-width: 749px)');
      const validScenes = scenes.map((scene) => scene.dataset.scene);
      let hasBrowsed = false;
      let manualSummary = false;
      let copySequence = 0;

      const setView = (value, announce = true) => {
        if (value !== 'overview' && !validScenes.includes(value)) return;
        root.dataset.view = value;
        choices.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.sceneChoice === value)));
        scenes.forEach((scene) => scene.toggleAttribute('data-active', scene.dataset.scene === value));
        details.forEach((detail) => { detail.hidden = value !== 'overview' && detail.dataset.detail !== value; });
        showAll.disabled = value === 'overview';
        if (announce) sceneStatus.textContent = value === 'overview' ? messages.overview : messages[value];
      };

      choices.forEach((button) => {
        button.addEventListener('click', () => {
          hasBrowsed = true;
          setView(button.dataset.sceneChoice);
        });
        button.addEventListener('keydown', (event) => {
          const group = button.closest('[role="group"]') || button.closest('[data-scenes]');
          const groupButtons = [...group.querySelectorAll('[data-scene-choice]')];
          const index = groupButtons.indexOf(button);
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % groupButtons.length;
          else if (event.key === 'ArrowLeft') next = (index + groupButtons.length - 1) % groupButtons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = groupButtons.length - 1;
          else if (event.key === 'Escape') {
            hasBrowsed = true;
            setView('overview');
            event.preventDefault();
            return;
          } else return;
          event.preventDefault();
          groupButtons[next].focus();
        });
      });
      showAll.addEventListener('click', () => { hasBrowsed = true; setView('overview'); });

      const optionText = (select) => select.value ? select.selectedOptions[0].textContent.trim() : '';
      const builtText = () => {
        const lines = [];
        if (application.value) lines.push(`${messages.applicationLabel}: ${optionText(application)}`);
        if (equipment.value) lines.push(`${messages.equipmentLabel}: ${optionText(equipment)}`);
        if (equipment.value === 'known' && model.value.trim()) lines.push(`${messages.modelLabel}: ${model.value.trim()}`);
        if (evidence.value) lines.push(`${messages.evidenceLabel}: ${optionText(evidence)}`);
        return lines.join('\n');
      };
      const updateCopy = () => { copyButton.disabled = !summary.value.trim(); };
      const clearCopy = () => { copySequence += 1; copyState.textContent = ''; };
      const updateBrief = () => {
        clearCopy();
        if (equipment.value !== 'known') model.value = '';
        modelField.hidden = equipment.value !== 'known';
        if (manualSummary) {
          briefState.textContent = messages.edited;
          rebuildButton.hidden = false;
        } else {
          summary.value = builtText();
          briefState.textContent = summary.value ? messages.generated : messages.empty;
          rebuildButton.hidden = true;
        }
        updateCopy();
      };
      [application, equipment, evidence].forEach((select) => select.addEventListener('change', updateBrief));
      model.addEventListener('input', updateBrief);
      summary.addEventListener('input', () => {
        clearCopy();
        manualSummary = true;
        briefState.textContent = messages.edited;
        rebuildButton.hidden = false;
        updateCopy();
      });
      rebuildButton.addEventListener('click', () => {
        manualSummary = false;
        updateBrief();
        summary.focus();
      });
      resetButton.addEventListener('click', () => {
        application.value = '';
        equipment.value = '';
        evidence.value = '';
        model.value = '';
        summary.value = '';
        manualSummary = false;
        updateBrief();
        copyState.textContent = messages.reset;
      });
      copyButton.addEventListener('click', async () => {
        const value = summary.value;
        if (!value.trim()) return;
        const sequence = ++copySequence;
        try {
          if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(value);
          if (sequence !== copySequence) return;
          copyState.textContent = summary.value === value ? messages.copied : messages.copyChanged;
        } catch {
          if (sequence !== copySequence) return;
          brief.open = true;
          summary.focus();
          summary.select();
          summary.setSelectionRange(0, summary.value.length);
          copyState.textContent = messages.copyFallback;
        }
      });
      root.querySelectorAll(`a[href="#${brief.id}"]`).forEach((link) => {
        link.addEventListener('click', () => { brief.open = true; });
      });
      mobile.addEventListener('change', (event) => {
        if (!hasBrowsed) setView(event.matches ? validScenes[0] : 'overview', false);
      });
      let wasBriefOpen = false;
      window.addEventListener('beforeprint', () => {
        wasBriefOpen = brief.open;
        brief.open = true;
        printSummary.textContent = summary.value;
        brief.toggleAttribute('data-print-empty', !summary.value.trim());
      });
      window.addEventListener('afterprint', () => {
        brief.open = wasBriefOpen;
        printSummary.textContent = '';
        brief.removeAttribute('data-print-empty');
      });
      application.value = '';
      equipment.value = '';
      evidence.value = '';
      model.value = '';
      summary.value = '';
      brief.open = !mobile.matches;
      updateBrief();
      setView(mobile.matches ? validScenes[0] : 'overview', false);
      root.querySelectorAll('[data-enhance-only]').forEach((element) => { element.hidden = false; });
      root.dataset.ready = 'true';
    };
    document.querySelectorAll('[data-pm-applications]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-pm-applications]').forEach(init);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
